var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui column grid centered"},[_c('div',{staticClass:"seven wide column"},[(_vm.newCampaign)?_c('t-form-new-campaign'):_c('t-form-edit-campaign')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }